import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

export const OverrideBadge = () => (
  <Chip
    label='Override'
    size='small'
    sx={{
      backgroundColor: '#FFF9C4',
      color: '#8D6E63',
      fontWeight: 500,
      fontSize: '0.6rem',
      height: '16px',
      minHeight: '16px',
      lineHeight: '16px',
      border: '1px solid',
      borderColor: '#F9A825',
      borderRadius: '4px',
      '& .MuiChip-label': {
        padding: '0 6px',
        fontSize: '0.6rem',
        lineHeight: '16px',
      },
    }}
  />
);

export const NoChangesBadge = () => (
  <Chip
    label='No changes'
    size='small'
    sx={{
      backgroundColor: '#E8F5E9',
      color: '#2E7D32',
      fontWeight: 500,
      fontSize: '0.6rem',
      height: '16px',
      minHeight: '16px',
      lineHeight: '16px',
      border: '1px solid',
      borderColor: '#66BB6A',
      borderRadius: '4px',
      '& .MuiChip-label': {
        padding: '0 6px',
        fontSize: '0.6rem',
        lineHeight: '16px',
      },
    }}
  />
);

export const StatusBadge = ({ status }) => {
  const getStatusColor = () => {
    switch (status?.toUpperCase()) {
      case 'ACTIVE':
        return { backgroundColor: '#4CAF50', color: '#FFFFFF' };
      case 'INACTIVE':
        return { backgroundColor: '#9E9E9E', color: '#FFFFFF' };
      default:
        return { backgroundColor: '#2196F3', color: '#FFFFFF' };
    }
  };

  return (
    <Chip
      label={status || 'Active'}
      size='small'
      sx={{
        ...getStatusColor(),
        fontWeight: 500,
        fontSize: '0.75rem',
        height: '20px',
      }}
    />
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
};

StatusBadge.defaultProps = {
  status: 'Active',
};
